import React from 'react';
import PropTypes from 'prop-types';

import pure from '../../lib/pure';
import * as styles from './styles.css';
import IconPopover from '../../components/IconPopover';

function Indicator({ label, touched, warning, error, dirty, tooltipPlacement }) {
  return (
    <div className={styles.iconContainer}>
      {touched && !warning && !error &&
      <i className={`fa fa-check-circle text-success ${styles.icon}`} />}
      {(touched || dirty) && error &&
      (
        <IconPopover title={label} iconClasses={`fa-exclamation-circle fa-2x text-danger ${styles.icon}`} tooltipPlacement={tooltipPlacement}>
          <span>{error}</span>
        </IconPopover>
      )}
       {(touched || dirty) && warning &&
      (
        <IconPopover title={label} iconClasses={`fa-exclamation-circle fa-2x text-warning ${styles.icon}`} tooltipPlacement={tooltipPlacement}>
          <span>{warning}</span>
        </IconPopover>
      )}
    </div>
  );
}

Indicator.defaultProps = {
  touched: undefined,
  dirty: undefined,
  warn: undefined,
  error: undefined,
};

Indicator.propTypes = {
  label: PropTypes.string.isRequired,
  touched: PropTypes.bool,
  dirty: PropTypes.bool,
  warn: PropTypes.string,
  error: PropTypes.string,
};

export default pure(Indicator);
